import HourglassTopIcon from '@mui/icons-material/HourglassTop';
import Page from "../../../components/Page";
import Article from "../../../components/Article";
import CustomButton from '../../../components/CustomButton';
import { useLocation, useNavigate } from 'react-router-dom';
import { Routes } from '../../../routes/RouteConstants';
import { Box, keyframes, Typography, useTheme } from '@mui/material';
import { useTenant } from '../../../contexts/TenantContext';
import { gradientFillSx, tint } from '../../../utils/textStyles';
import { isDarkTheme, isNeonTheme } from '../../../utils/themeTraits';
import ProviderLine from '../../provider/components/ProviderLine';

const rotate = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(180deg); }
`

/**
 * The hourglass disc, painted like the profile's initials disc. A dark theme fills it with the
 * gradient of its action colour, with the glyph in the button's ink: on a coloured glow on the
 * neon theme, on a black shadow on the plain one. Paper keeps its light primary disc with a white
 * glyph, on a neutral shadow.
 */
const discSx = (displayConfig, theme) => {
  if (isDarkTheme(displayConfig)) {
    const glow = isNeonTheme(displayConfig) ? displayConfig?.buttonColor : "#000";

    return {
      ...gradientFillSx(displayConfig, displayConfig?.buttonColor, { hover: false }),
      boxShadow: `0 12px 30px -14px ${tint(glow, 0.9)}`,
    };
  }

  return {
    backgroundColor: theme.palette.primary.light,
    boxShadow: `0 8px 24px ${tint("#000", 0.15)}`,
  };
};

const PendingApprovalPage = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const { displayConfig } = useTenant();
  // Handed over by the confirmation page; gone after a reload, when the page simply says less.
  const booking = useLocation().state?.booking;
  const glyphColor = isDarkTheme(displayConfig) ? displayConfig?.buttonTextColor || "#000" : "common.white";

  return (
    <Page>
      <Article
        title="A foglalás jóváhagyásra vár"
        titleVariant="h5"
        alignItems="center"
      >
        <Box
          sx={{
            width: 120,
            height: 120,
            borderRadius: "50%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginBottom: 3,
            ...discSx(displayConfig, theme),
          }}
        >
          <HourglassTopIcon
            sx={{
              fontSize: 64,
              color: glyphColor,
              animation: `${rotate} 2s ease-in-out infinite`,
            }}
          />
        </Box>
      
        <ProviderLine providerId={booking?.providerId} sx={{ mb: 2 }} />

        <Typography align="center" mb={4} color={displayConfig?.color}>
          E-mailben értesítünk, amint az időpontot megerősítik.
        </Typography>

        <CustomButton
          variant="outlined"
          text="Foglalás megtekintése"
          onClick={() => navigate(Routes.PROFILE)}
          mt={1}
        />
      </Article>
    </Page>
  );
};

export default PendingApprovalPage;
